import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../utils/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params }     from '@angular/router';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-po-details',
  templateUrl: './po-details.component.html',
  styleUrls: ['./po-details.component.scss']
})
export class PoDetailsComponent implements OnInit {
  
  purchaseOrder:any;

  constructor(
    public adminService: AdminService,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute,
  ) { }


  ngOnInit() {
    this.loaderService.display(true);
    this.route.params.subscribe(params => {
      this.adminService.getPoDetails(params['id']).subscribe(
      res => {
        console.log(res);
        this.purchaseOrder = res;
        this.loaderService.display(false);

       }, err => {

        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
      )
    });
  }

  goToPOLink(purchaseOrderId){
    this.loaderService.display(true);
    this.adminService.viewPurchaseOrderPdf(purchaseOrderId).subscribe(
      res => {
        window.open(res.url, "_blank");
        this.loaderService.display(false);
      }, 
      err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }

  goToBOMLink(purchaseOrderId){
    this.loaderService.display(true);
    this.adminService.viewBOMPdf(purchaseOrderId).subscribe(
      res => {
        window.open(res.url, "_blank");
        this.loaderService.display(false);
      }, 
      err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }

  downloadPartFile(purchaseOrderId, itemId){
    this.loaderService.display(true);
    this.adminService.viewPartModelFile(purchaseOrderId, itemId).subscribe(
      res => {
        window.location.href = res.url;
        this.loaderService.display(false);
      }, 
      err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }

  downloadAllFilesZip(purchaseOrderId){
    this.loaderService.display(true);
    this.adminService.downloadZipFile(purchaseOrderId).subscribe(
      res => {
        window.location.href = res.url;
        this.loaderService.display(false);
      }, 
      err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }

}
